const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

function getState(zipcode) {
  // Ensure param is a string to prevent unpredictable parsing results
  if (typeof zipcode !== 'string') {
    throw new Error(
      "'Must pass the zipcode as a string. -- Otherwise leading zeros could cause your zip code to be parsed outside base 10.'"
    )
  }

  // Ensure you don't parse codes that start with 0 as octal values
  const zip = parseInt(zipcode, 10)
  const state = window.STATES_LIST_LOOKUP.find(s => s.min <= zip && s.max >= zip)

  return { code: state?.code, long: state?.long }
}

const {
  checkoutIntervalPerDays,
  defaultCheckoutInterval,
  specialDaysHour,
  allDaysHour,
  sameDayMaxTime,
  sameDayOptions
} = window.CART_PAGE_CONFIG

function generatePickerOptions(firstDate, secondDate, time, pickerOptions) {
  let options = ''
  if (firstDate === secondDate) {
    pickerOptions.map(el => {
      if (time > el[0] && time < el[1]) {
        options += `<option value="${el[2]}">${el[2]}</option>`
      }
    })
  } else {
    pickerOptions.map(el => {
      if (el[2] !== 'ASAP') {
        options += `<option value="${el[2]}">${el[2]}</option>`
      }
    })
  }
  return options
}

function areDatesEqual(date1, date2) {
  return +date1.setHours(0, 0, 0, 0) === +date2.setHours(0, 0, 0, 0)
}

function getTimeIntervalsOptions(time, pickerOptions, isSameDay) {
  return isSameDay
    ? pickerOptions.filter(el => time > el[0] && time < el[1])
    : pickerOptions.filter(el => el[2] !== 'ASAP')
}

function addOptionsToSelect(select, options) {
  select.innerHTML = ''

  options.map(option => {
    select.add(new Option(option[2], option[2]))
  })
}

class CartZipcodeCheck extends HTMLElement {
  constructor() {
    super()

    this.sectionId = this.getAttribute('data-section-id')
    this.shopLocationCode = this.getAttribute('data-shop-location-code')
    this.productHandle = this.getAttribute('data-product-handle')
    this.timeInterval = this.querySelector('[data-time-interval-select]')
    this.nextDayInterval = this.querySelector('[next-day-date-time-interval-select]')
    this.TAPRM_ZIPCODES = null
    this.checkout = this.querySelector('#checkout-btn')
    this.delivetyType = null

    this.deliveryTypes = {
      zip_codes: {
        el: this.querySelector('[data-regular-delivery]'),
        method: this.handleRegularDeliverySelect.bind(this),
        date: null,
        time: '3 - 10 Day Shipping'
      },
      next_day_delivery: {
        el: this.querySelector('[data-next-day-delivery]'),
        method: this.handleNextDayDeliverySelect.bind(this),
        date: this.querySelector('#next-date-datepicker'),
        time: 'Next Day Delivery'
      },
      delivery_zip_codes: {
        el: this.querySelector('[data-local-delivery]'),
        method: this.handleLocalDeliverySelect.bind(this),
        date: this.querySelector('#datepicker'),
        time: this.querySelector('#time-interval-select-same-day')
      }
    }

    this.currentLocationEl = this.querySelector('[data-zipcode-current-location]')

    this.zipcodeFormWrapEl = this.querySelector('[data-zipcode-form-wrap]')
    this.zipcodeLocationTitle = this.querySelector('[data-zipcode-current-location-text]')

    this.zipcodeForm = this.querySelector('[data-zipcode-form]')
    this.zipcodeFormInput = this.zipcodeForm.querySelector('[name="zipcode"]')

    this.zipcodeFormErrorMessageEl = this.querySelector('[data-zip-format-error]')
    this.unvailableEl = this.querySelector('[data-zipcode-unavailable]')

    this.urlZipcode = new URL(window.location).searchParams.get('zipcode')
    this.formSubmitted = new URL(window.location).searchParams.get('customer_posted')
    this.storageZipcode = window.localStorage.getItem('customerZip')
    this.customerZipcode = this.urlZipcode || this.storageZipcode || null

    this.checkout.addEventListener('click', () => {
      this.handleCheckout()
    })

    this.zipcodeFormInput.addEventListener('input', event => {
      const value = event.target?.value

      this.zipcodeFormErrorMessageEl.classList.remove('hide')
      this.zipcodeFormErrorMessageEl.textContent = ''

      if ((value && value.length > 5) || value.length < 5) {
        Object.values(this.deliveryTypes).map(type => {
          type.el.classList.add('hide')
        })
        this.checkout.classList.add('disabled')
      }
    })

    this.zipcodeForm.addEventListener('submit', event => {
      event.preventDefault()
      this.checkZip(this.zipcodeForm.elements['zipcode'].value)
    })

    this.init()
  }

  init() {
    if (window.TAPRM_ZIPCODES) {
      this.TAPRM_ZIPCODES = window.TAPRM_ZIPCODES
      if (this.customerZipcode) {
        this.checkZip(this.customerZipcode, true)
      }

      this.zipcodeFormInput.value = this.customerZipcode
      return
    }

    fetch('https://cdn.shopify.com/s/files/1/0631/2191/6144/files/zipcodes.json?v=' + new Date().getTime())
      .then(function (res) {
        return res.json()
      })
      .then(body => {
        this.TAPRM_ZIPCODES = body.sunboyNY
        window.TAPRM_ZIPCODES = body.sunboyNY

        if (this.customerZipcode) {
          this.checkZip(this.customerZipcode, true)
        }

        this.zipcodeFormInput.value = this.customerZipcode
      })
  }

  checkZipFormat(zip) {
    let errorMessage = null

    if (!zip) {
      errorMessage = 'Please enter zipcode before submit!'
    } else if (zip.toString().length !== 5) {
      errorMessage = 'Zipcode must be 5 digits!'
    }

    this.zipcodeFormErrorMessageEl.classList.add('hide')
    // this.toggleProductBlocks(errorMessage !== null)

    if (errorMessage) {
      this.zipcodeFormErrorMessageEl.classList.remove('hide')
      this.zipcodeFormErrorMessageEl.textContent = errorMessage

      return false
    }

    this.customerZipcode = zip
    window.localStorage.setItem('customerZip', zip)

    return true
  }

  checkZipValid(zip, initialCheck = false) {
    if (!this.TAPRM_ZIPCODES) {
      this.init()
    }

    const type = Object.keys(this.TAPRM_ZIPCODES).reduce((acc, key) => {
      const zipCodes = Array.isArray(this.TAPRM_ZIPCODES[key]) ? this.TAPRM_ZIPCODES[key] : []
      return zipCodes.includes(zip) ? key : acc
    }, null)

    const state = getState(zip.toString())

    this.zipcodeLocationTitle.textContent = this.getUserCityState(state.code)

    if (type && this.deliveryTypes[type]) {
      return this.handleValidZip(type)
    }

    this.handleInvalidZip(zip)
  }

  getUserCityState(useLocationStateCode) {
    if (!useLocationStateCode) {
      return this.zipcodeLocationTitle.dataset.invalidZipText
    }

    let userCityState = `Location: ${useLocationStateCode}`

    const data = Object.entries(window.STATES_CITIES_ZIPCODES)

    for (const [stateCode, stateData] of data) {
      const userCity = Object.entries(stateData.cities).find(city => city[1].includes(Number(this.customerZipcode)))

      if (userCity) {
        userCityState = `Location: ${userCity[0]}, ${stateCode}, USA`
        break
      }
    }

    return userCityState
  }

  handleNextDayDeliverySelect() {
    const nextDay = new Date(new Date().setDate(new Date().getDate() + 1))
    const dayAfterNextDay = new Date(new Date().setDate(new Date().getDate() + 2))
    const time = nextDay.getHours()

    const $dateSelector = $('#next-date-datepicker').datepicker({
      minDate: nextDay,
      timeZone: 'America/New_York',
      maxDate: '+3D'
    })

    $dateSelector.datepicker('setDate', nextDay)

    if (time >= sameDayMaxTime) {
      $dateSelector.datepicker('option', { minDate: dayAfterNextDay, defaultDate: dayAfterNextDay, maxDate: '+4D' })
    }

    const intervals = getTimeIntervalsOptions(time, sameDayOptions, false)
    addOptionsToSelect(this.nextDayInterval, intervals)
  }

  handleRegularDeliverySelect() {
    console.log('regular')
  }

  handleLocalDeliverySelect() {
    const today = new Date()
    const time = today.getHours()
    const todayDayName = DAYS[today.getDay()]
    const timeIntervalSelect = this.timeInterval

    const endHour =
      todayDayName === 'Sunday' || todayDayName === 'Monday' || todayDayName === 'Tuesday'
        ? specialDaysHour
        : allDaysHour

    const isCurrentTimeBiggerThanOperational = time >= endHour
    const selectedDate = isCurrentTimeBiggerThanOperational
      ? new Date(new Date().setDate(new Date().getDate() + 1))
      : today

    // init datepicker
    const $dateSelector = $('#datepicker').datepicker({
      defaultDate: selectedDate,
      minDate: selectedDate,
      timeZone: 'America/New_York',
      maxDate: '+3D',
      onSelect: function (dateString, instance) {
        const selectedDate = new Date(dateString)
        const selectedDayName = DAYS[selectedDate.getDay()]

        const pickerOptions = checkoutIntervalPerDays[selectedDayName].length
          ? checkoutIntervalPerDays[selectedDayName]
          : defaultCheckoutInterval

        const intervals = getTimeIntervalsOptions(time, pickerOptions, areDatesEqual(selectedDate, today))
        addOptionsToSelect(timeIntervalSelect, intervals)
      }
    })

    $dateSelector.datepicker('setDate', selectedDate)

    const pickerOptions =
      checkoutIntervalPerDays[todayDayName] && checkoutIntervalPerDays[todayDayName].length > 0
        ? checkoutIntervalPerDays[todayDayName]
        : defaultCheckoutInterval

    const intervals = getTimeIntervalsOptions(time, pickerOptions, areDatesEqual(selectedDate, today))
    addOptionsToSelect(timeIntervalSelect, intervals)
  }

  checkZip(zip, initialCheck = false) {
    const zipFormatValid = this.checkZipFormat(zip)
    if (!zipFormatValid) return

    this.checkZipValid(zip, initialCheck)
  }

  handleToggleDeliveryByType(type) {
    Object.values(this.deliveryTypes).map(type => {
      type.el.classList.add('hide')
    })

    if (this.deliveryTypes[type]) {
      this.deliveryTypes[type].el.classList.remove('hide')
      this.deliveryTypes[type].method()
    }
  }

  handleValidZip(type, initialCheck = false) {
    this.checkout.classList.remove('disabled')
    this.delivetyType = type
    this.handleToggleDeliveryByType(type)
  }

  handleInvalidZip() {
    this.zipcodeFormErrorMessageEl.classList.remove('hide')
    this.zipcodeFormErrorMessageEl.textContent = "At the moment we don't ship to this location"
    this.checkout.classList.add('disabled')
  }

  handleCheckout() {
    const delivery = this.deliveryTypes[this.delivetyType]

    if (!delivery) return

    const date = delivery.date?.value || delivery.date
    const time = delivery.time?.value || delivery.time

    fetch('/cart/update.js', {
      ...fetchConfig(),
      body: JSON.stringify({
        attributes: {
          'Delivery-Zip-Code': this.zipcodeFormInput.value,
          Date: date,
          Time: time
        }
      })
    }).then(() => {
      this.querySelector('#checkout').click()
    })
  }
}

customElements.define('cart-zipcode-check', CartZipcodeCheck)
